import { ForwardTradeWithdrawModalProps } from "./forward-trade-withdraw-modal.types";
import { ForwardTradeWithdrawModalView } from "./forward-trade-withdraw-modal-view";
import { useForwardTradeWithdrawModal } from "./use-forward-trade-withdraw-modal";

export const ForwardTradeWithdrawModal = ({
  tradeID,
  registryCode,
  closeModal,
  ...rest
}: ForwardTradeWithdrawModalProps) => {
  const logic = useForwardTradeWithdrawModal({ tradeID, registryCode, closeModal });
  return <ForwardTradeWithdrawModalView {...logic} {...rest} />;
};
